import React from 'react';
import { cn } from '@/utils';
import FilePill from '../FilePill/FilePill';

export default function FilePills({
  files,
  children,
  className,
}: {
  files?: App.Data.FileData[];
  children?: React.ReactNode;
  className?: string;
}) {
  return (
    <div className={cn('flex flex-wrap items-center gap-1', className)}>
      {files?.map(f => (
        <FilePill key={f.id} file={f} />
      ))}
      {children}
    </div>
  );
}
